module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "article first-article",
    attrs: {
      "href": _vm.article.link
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.openArticle(_vm.article.slug)
      }
    }
  }, [_c('figure', {
    staticClass: "article-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.article.media[_vm.thumbnail].url,
      "alt": _vm.article.media[_vm.thumbnail].alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "article-body"
  }, [_c('h2', {
    staticClass: "article-title",
    domProps: {
      "innerHTML": _vm._s(_vm.article.title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.article.description)
    }
  }), _vm._v(" "), _c('footer', {
    staticClass: "article-info"
  }, [_c('span', [_vm._v(_vm._s(_vm.article.formatted_date))]), _vm._v(" "), _c('span', [_c('tags', {
    attrs: {
      "categories": _vm.article.categories || []
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79e9090a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/news/news-main.vue
// module id = 183
// module chunks = 4